import React, { useEffect, useRef, useState } from "react";
import { queryAllChannel } from "../../../service";
import "./style.scss";
import { Link } from "react-router-dom";

export default function TabList({ No, defaultTab, iframeVisible }) {
  const [tabMap, setTabMap] = useState({});
  const tabRef = useRef(null);
  useEffect(() => {
    queryAllChannel(No).then((res) => {
      const ChannelsMap = {};
      res.records.forEach((item) => {
        ChannelsMap[item.channelNo] = item.channelName;
      });
      setTabMap(ChannelsMap);
    });
  }, [No]);

  useEffect(() => {
    if (tabRef.current) {
      const activeTab = tabRef.current.querySelector(".active");
      if (activeTab) {
        if (activeTab.offsetLeft > 265) {
          const left = activeTab.offsetLeft + 6;
          tabRef.current.scrollTo({
            left,
            behavior: "smooth",
          });
        }
        if (activeTab.offsetLeft < 265) {
          tabRef.current.scrollTo({
            left: 0,
            behavior: "smooth",
          });
        }
      }
    }
  }, [defaultTab]);

  return (
    <div
      className={
        No === "QXStart" ? "tab-inner-list" : "tab-inner-list tab-inner-list2"
      }
      style={{
        opacity: iframeVisible ? 0 : 1,
        pointerEvents: iframeVisible ? "none" : "auto",
      }}
    >
      <ul ref={tabRef}>
        {Object.keys(tabMap).map((item) => {
          return (
            <li className={defaultTab === item ? "active" : ""} key={item}>
              <Link to={`/GQKP/${item}`}>{tabMap[item]}</Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
